import { Quote, BadgeCheck } from "lucide-react";

const INK = "#0F1B2D";
const YELLOW = "#E0663F";
const AMBER = "#0E509C";

const QUOTES = [
  {
    q: "Colin is not just an expert; he exudes professionalism and credibility. Compliance credibility is a cornerstone for a company's reputation in the fintech sector, and Colin consistently instills confidence in clients and stakeholders.",
    name: "Pia Thompson",
    title: "CEO · FinTech & Financial Services · Founder, lawesomeGC",
  },
  {
    q: "Colin is a knowledgeable and thoughtful professional. He brings a rare combination of expertise along with a commercial approach which make him a good leader and desired partner.",
    name: "Adam Goller",
    title: "EVP, Head of Fintech Banking · Cross River",
  },
  {
    q: "Colin was key in establishing Rocket Loans. His expertise allowed us to establish sound regulatory practices day-1 — he doesn't just follow what others have done, but understands the regulatory environment and, in our case, helped establish new standards adopted throughout the industry.",
    name: "Todd Lunsford",
    title: "Managed Colin directly · Rocket Loans",
  },
];

const CLIENT_QUOTES = [
  {
    q: "You need the right partner. We chose the right partner with CompliSun, and I honestly don't see bringing in a whole Compliance Department again. With CompliSun, the work gets done, no sacrifices, and far better quality than one would get from most fulltime hires.",
    name: "Pia Thompson",
    title: "CEO · Checkbook",
  },
  {
    q: "Partnering with CompliSun Guardian was instrumental in strengthening our compliance management systems. It significantly reduced both cost and time when implementing marketing audits and securing our lending licenses.",
    name: "Mark Mughabghab",
    title: "CEO · RNPL Credit",
  },
];

function QuoteCard({ q, name, title, testid }) {
  return (
    <figure className="rt-card p-6 flex flex-col" data-testid={testid}>
      <Quote className="h-5 w-5 mb-3 flex-shrink-0" style={{ color: YELLOW, fill: YELLOW }} />
      <blockquote className="text-[14px] leading-relaxed flex-1" style={{ color: INK, opacity: 0.8 }}>
        &ldquo;{q}&rdquo;
      </blockquote>
      <figcaption className="mt-4 pt-4 flex items-start gap-2" style={{ borderTop: "1px solid rgba(17,17,17,0.08)" }}>
        <BadgeCheck className="h-4 w-4 mt-0.5 flex-shrink-0" style={{ color: AMBER }} />
        <div>
          <div className="text-[13px] font-extrabold" style={{ color: INK }}>{name}</div>
          <div className="text-[11.5px]" style={{ color: INK, opacity: 0.55 }}>{title}</div>
        </div>
      </figcaption>
    </figure>
  );
}

export function ClientQuotes() {
  return (
    <section id="clients" className="anchor-target py-10 md:py-14" data-testid="client-quotes-section">
      <span className="rt-eyebrow">What clients say</span>
      <h2 className="rt-h text-3xl md:text-4xl mt-3 max-w-3xl">
        Teams that chose CompliSun <span className="rt-grad-text">don't go back.</span>
      </h2>
      <div className="mt-7 grid grid-cols-1 md:grid-cols-2 gap-4 max-w-5xl">
        {CLIENT_QUOTES.map((c, i) => (
          <QuoteCard key={c.name} {...c} testid={`client-quote-${i}`} />
        ))}
      </div>
    </section>
  );
}

export function ExpertQuotes() {
  return (
    <section id="expert" className="anchor-target py-14 md:py-20" data-testid="expert-section">
      <span className="rt-eyebrow">The expert behind it</span>
      <h2 className="rt-h text-4xl md:text-5xl mt-3 max-w-3xl">
        Colin Darke — <span className="rt-grad-text">the practitioner behind your program.</span>
      </h2>
      <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-6">
        <img src="/brand/colin.jpg" alt="Colin Darke" data-testid="colin-headshot"
             className="h-32 w-32 rounded-2xl object-cover flex-shrink-0"
             style={{ border: `3px solid ${YELLOW}` }} />
        <div>
          <p className="text-lg leading-relaxed max-w-3xl" style={{ color: INK, opacity: 0.78 }}>
            More than 20 years in compliance and law — bank roles, then <strong>General Counsel and Chief
            Compliance Officer at Rocket Loans</strong>, where he helped take the company public. Recently
            recognized by <strong>Best Lawyers 2027</strong> in Banking and Finance and Corporate Law.
            Co-founder of the <strong>Online Lending Policy Institute</strong> — now the
            <strong> American Fintech Council</strong>.
          </p>
          <img src="/brand/best-lawyers-2027.png" alt="Colin Darke — Recognized by Best Lawyers 2027"
               data-testid="best-lawyers-badge"
               className="mt-4 h-16 w-auto rounded-md"
               style={{ border: "1px solid rgba(17,17,17,0.12)" }} />
        </div>
      </div>
      <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-4">
        {QUOTES.map((c, i) => (
          <QuoteCard key={c.name} {...c} testid={`expert-quote-${i}`} />
        ))}
      </div>
      <p className="mt-4 text-[11px]" style={{ color: INK, opacity: 0.5 }}>
        Quotes from public LinkedIn recommendations.
      </p>
    </section>
  );
}
